import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarBlank } from "@phosphor-icons/react";
import { format, parse, isValid } from "date-fns";

// Robustly parse a stored date string (imported data may not be clean ISO).
// Returns a valid Date or undefined — never an Invalid Date (which crashes date-fns format()).
function parseValue(value) {
  if (!value || typeof value !== "string") return undefined;
  const v = value.trim();
  if (!v) return undefined;
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const d = new Date(`${v}T00:00:00`);
    return isValid(d) ? d : undefined;
  }
  for (const fmt of ["dd/MM/yyyy", "dd-MM-yyyy", "MM/dd/yyyy", "yyyy/MM/dd", "dd MMM yyyy", "dd MMMM yyyy"]) {
    const d = parse(v, fmt, new Date());
    if (isValid(d)) return d;
  }
  const d = new Date(v);
  return isValid(d) ? d : undefined;
}

export function DateField({ value, onChange, testId, placeholder = "Pick a date" }) {
  const selected = parseValue(value);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="rounded-sm w-full justify-start font-normal" data-testid={testId}>
          <CalendarBlank size={15} className="mr-2 text-muted-foreground shrink-0" />
          {selected ? format(selected, "dd MMM yyyy") : <span className="text-muted-foreground">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={selected} onSelect={(d) => onChange(d && isValid(d) ? format(d, "yyyy-MM-dd") : "")} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
